import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { CONTENT_PERILAKU_KERJA } from 'app/KinerjaPSPegawaiPage/configs/content-perilaku-kerja'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

function PanduanPerilakuKerja(_props: any) {
  const router = useRouter()

  const handleBack = () => {
    const isNewActivity = window.history.length <= 2
    if (isNewActivity) {
      router.push(`${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/beranda`)
    } else {
      router.back()
    }
  }

  return (
    <div className="min-h-full px-8 pb-8 bg-gray-10">
      <div className="mx-auto max-w-7xl">
        <Header
          title="Daftar Perilaku Kerja"
          className="mb-9 print:hidden"
          onBack={handleBack}
        />

        <div className="mt-12 bg-white rounded-lg">
          <div className="p-9">
            <div className="flex flex-col gap-10">
              {CONTENT_PERILAKU_KERJA.aspek.map((aspek, i) => {
                return (
                  <div
                    key={`aspek-${i}`}
                    className="p-6 border rounded border-gray-30"
                  >
                    <div className="flex flex-col gap-6">
                      <div className="flex gap-2.5 items-center">
                        <div className="flex items-center justify-center w-6 h-6 p-3 rounded-full bg-blue-70">
                          <div className="absolute flex">
                            <Text
                              color="inverse"
                              className="!font-bold !text-sm"
                            >
                              {i + 1}
                            </Text>
                          </div>
                        </div>
                        <Text variant="display-sm">{aspek.value}</Text>
                      </div>

                      {aspek.indikator.map((indikator, j) => {
                        return (
                          <div
                            className="flex flex-col gap-6 pb-6 border-b border-b-subdued last:border-b-0 last:pb-0"
                            key={`indikator-${j}`}
                          >
                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Indikator</Text>
                              <Text>
                                {i + 1}.{j + 1} {indikator.value}
                              </Text>
                            </div>

                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Perwujudan</Text>
                              {indikator.ekspektasi.map((ekspektasi, k) => [
                                <Text key={`perwujudan-${k}`}>
                                  {i + 1}.{j + 1}.{k + 1} {ekspektasi.value}
                                </Text>,
                              ])}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function WrappedPanduanPerilakuKerja(_props: any) {
  return <PanduanPerilakuKerja />
}

export default WrappedPanduanPerilakuKerja
